import React from 'react';
import { Field } from 'redux-form';
import { TextAreaField } from 'redux-form-antd';
import PropTypes from 'prop-types';
import { Button, Col, Row, Modal, Icon, Spin } from 'antd';

const formItemLayout = {
  colon: false,
  labelCol: {
    xs: { span: 12 },
    sm: { span: 4 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 24 },
  },
};

const BigQueryModal = ({
  title,
  onHideBigQuery,
  loadingAudienceQuery,
  loading,
  visible,
  submitText,
  deviceCount,
  handleRunTest,
  children,
  hideModal,
}) => (
  <Modal
    onCancel={hideModal}
    width={800}
    title={title}
    visible={visible}
    footer={[
      <Button key="back" onClick={hideModal}>
        Cancel
      </Button>,
      <Button key="submit" type="primary" loading={loadingAudienceQuery} onClick={onHideBigQuery}>
        {submitText}
      </Button>,
    ]}
  >
    <Spin spinning={loadingAudienceQuery || loading}>
      <Row>
        <Col span={24}>
          {children}
          <Field {...formItemLayout} name="query" component={TextAreaField} rows={15} />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Field
            style={{ marginRight: '10px', marginBottom: '5px' }}
            name="useStandardSql"
            component="input"
            type="checkbox"
            label="Use Standard SQL?"
          />
          Use Standard SQL?
        </Col>
      </Row>
    </Spin>
    {handleRunTest ? (
      <Button onClick={handleRunTest} loading={loadingAudienceQuery}>
        Run Query
      </Button>
    ) : null}
    <p style={{ marginTop: 15, paddingBottom: 0, marginBottom: 0 }}>
      <Icon type="question-circle-o" style={{ fontSize: 16, color: '#08c', paddingRight: 5 }} />
      {`To ensure your query runs correctly: Name your device column "devices" so the system can find it, and if you're splitting your group by day of the week include "and {{dayofweek:your_datetime_column}}" in the WHERE clause.`}
    </p>
    {!loadingAudienceQuery && deviceCount ? (
      <h2 style={{ display: 'inline' }}>{deviceCount.toLocaleString()} Devices will be targeted</h2>
    ) : null}
  </Modal>
);

BigQueryModal.defaultProps = {
  title: 'Create Query',
  submitText: 'Create',
  visible: false,
  loading: false,
  runAudienceQuery: null,
};

BigQueryModal.propTypes = {
  title: PropTypes.string,
  submitText: PropTypes.string,
  runAudienceQuery: PropTypes.func,
  onHideBigQuery: PropTypes.func.isRequired,
  visible: PropTypes.bool,
  loading: PropTypes.bool,
  loadingAudienceQuery: PropTypes.bool.isRequired,
  deviceCount: PropTypes.number.isRequired,
};

export default BigQueryModal;
